import { useEffect } from 'react'

export default function FourOhFour() {
  useEffect(() => {
    window.location.assign('/404')
  }, [])

  return null
}
